import { Link, Stack } from '@mui/material';
import useColorsStyles from 'common/colors';
import useFlexBoxStyles from 'common/flexBox';
import useFontStyles from 'common/fontStyles';
import useOnliveStyles from 'common/onliveStyles';
import { useTranslation } from 'react-i18next';
import useStickerStyles from './styles/Sticker.styles';

const Download = ({ asset, size, disabled }) => {
    const { classes, cx } = useStickerStyles();
    const { classes: flexBox } = useFlexBoxStyles();
    const { classes: colors } = useColorsStyles();
    const { classes: font } = useFontStyles();
    const { classes: onlive } = useOnliveStyles();

    const { t } = useTranslation();

    const rootStyle = {};
    if (asset.color) {
        rootStyle.backgroundColor = asset.color;
    }

    const proceedButton = (
        <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            className={cx(
                classes.proceedButton,
                flexBox.borderBottomRadius2,
                flexBox.cursorPointer,
                flexBox.w100,
                flexBox.textAlignCenter,
                font.bold,
                'secondary',
                size,
            )}
        >
            {t('callToAction.callToActionItem.downloadNow').toUpperCase()}
        </Stack>
    );

    return (
        <Stack
            direction="column"
            className={cx(
                colors.bgPaper,
                flexBox.borderRadius2,
                flexBox.relative,
                flexBox.overflowHidden,
                flexBox.borderBox,
                classes.width,
                onlive.boxShadowWeb,
                classes.minWidth,
            )}
        >
            <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                className={cx(flexBox.grow1, flexBox.textAlignCenter, flexBox.padding2)}
                style={rootStyle}
            >
                <span className={cx(classes.bodyText, font.clamp, font.clampLine3)}>{asset.text}</span>
            </Stack>
            <div className={cx(flexBox.w100, flexBox.borderBottomRadius1)}>
                {disabled ? (
                    proceedButton
                ) : (
                    <Link
                        component={'a'}
                        href={asset.url}
                        underline="none"
                        download
                        target="_blank"
                        disabled={disabled}
                    >
                        {proceedButton}
                    </Link>
                )}
            </div>
        </Stack>
    );
};

export default Download;
